import type { SxProps } from '@mui/material';
import type { KeyOrderCase } from '../../../types';

import useTranslation from 'shared/hooks/useTranslation';
import formatDate from 'shared/utils/formatDate';
import safeParseHtml from 'shared/utils/safeParseHtml';

import {
  Card,
  CardContainer,
  CardTitle,
  Item,
  List,
  ListContainer,
  Label,
  ListTitle,
  Value,
} from 'shared/components/styled/Cases';
import CheckIcon from 'shared/icons/Check';
import ClearIcon from 'shared/icons/Clear';

const toFormatedDate = (str: string | null) =>
  str ? formatDate(new Date(str)) : null;

const renderVariantIcon = (flag: boolean) => {
  const sx: SxProps = { fontSize: '1.3rem' };

  return flag ? (
    <CheckIcon color="success" sx={sx} />
  ) : (
    <ClearIcon color="error" sx={sx} />
  );
};

type CaseInfoProps = {
  keyOrder: KeyOrderCase;
};

const CaseInfo = ({ keyOrder }: CaseInfoProps) => {
  const { t } = useTranslation();

  return (
    <CardContainer>
      <CardTitle>{t('Information')}</CardTitle>
      <Card>
        <ListContainer>
          <List>
            <Item>
              <Label>{t('##attribute#incident#createdon')}</Label>
              <Value>{toFormatedDate(keyOrder.CreatedOn)}</Value>
            </Item>
            <Item>
              <Label>{t('##attribute#incident#modifiedon')}</Label>
              <Value>{toFormatedDate(keyOrder.ModifiedOn)}</Value>
            </Item>
          </List>
        </ListContainer>

        <ListContainer>
          <ListTitle>Kohde</ListTitle>
          <List>
            <Item>
              <Label>{t('##attribute#uds_space#uds_cooperativeid')}</Label>
              <Value>{keyOrder.Cooperative?.Name}</Value>
            </Item>
            <Item>
              <Label>{t('##attribute#incident#uds_spaceid')}</Label>
              <Value>{keyOrder.Space?.Name}</Value>
            </Item>
            <Item>
              <Label>Tilaaja</Label>
              <Value>{keyOrder.ContactPerson?.Name}</Value>
            </Item>
          </List>
        </ListContainer>

        <ListContainer>
          <ListTitle>Tilauksen tiedot</ListTitle>
          <List>
            <Item>
              <Label>{t('##attribute#incident#uds_keyordertype')}</Label>
              <Value>{keyOrder.KeyOrderType?.Label}</Value>
            </Item>
            <Item>
              <Label>{t('##attribute#incident#uds_keysamount')}</Label>
              <Value>{keyOrder.AmountOfKeys}</Value>
            </Item>
            <Item>
              <Label>{t('##attribute#incident#uds_typeofthekey')}</Label>
              <Value>{keyOrder.TypeOfTheKey}</Value>
            </Item>
            <Item>
              <Label>{t('##attribute#incident#uds_keynumber')}</Label>
              <Value>{keyOrder.KeyNumber}</Value>
            </Item>
            <Item direction="column">
              <Label>Lisätiedot</Label>
              <Value
                sx={{
                  justifyContent: 'flex-start',
                  textAlign: 'left',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {keyOrder.AdditionalInformation &&
                  safeParseHtml(keyOrder.AdditionalInformation)}
              </Value>
            </Item>
          </List>
        </ListContainer>

        <ListContainer>
          <ListTitle>Seuranta</ListTitle>
          <List>
            <Item>
              <Label>{t('##attribute#incident#uds_needsendsms')}</Label>
              <Value>{renderVariantIcon(keyOrder.SendSms)}</Value>
            </Item>
            <Item>
              <Label>{t('##attribute#incident#uds_needsendemail')}</Label>
              <Value>{renderVariantIcon(keyOrder.SendEmail)}</Value>
            </Item>
          </List>
        </ListContainer>
      </Card>
    </CardContainer>
  );
};

export default CaseInfo;
